// src/lib/contactRules.js — what may stand in a contract party's phone and email box.
// Moved out of ContractComposer.jsx (2026-09-21) so it can be tested: node --test cannot import a
// .jsx, and this is the rule behind the owner's 2026-09-12 ruling on nonsense contacts — a rule
// whose only proof was a browser is one edit away from reopening the hole it closed.

export function normalizePhone(raw) {
  const s = String(raw ?? '').trim()
  if (!s) return ''
  if (/[^0-9+()\s.-]/.test(s)) return s              // letters in it — not ours to repair
  let d = s.replace(/[^0-9+]/g, '')
  if (d.startsWith('00')) d = '+' + d.slice(2)        // the other way of writing +
  else if (!d.startsWith('+') && d.startsWith('995')) d = '+' + d
  else if (!d.startsWith('+') && /^[0-9]{9}$/.test(d)) d = '+995' + d
  // 🌍 A FULL INTERNATIONAL NUMBER THAT LOST ITS + (2026-09-21). Only Georgian shapes were
  // repaired, so a Ukrainian mobile stored as `380964442379` came back unchanged and contactProblems
  // flagged it — rendered "client — phone", which reads exactly like "missing", beside a box that
  // visibly held a number. Found creating an advance for a real client; measured across party:
  // 69 of 53,004 phones are this shape, every one of them a foreign client, and this function's own
  // header says the client on these contracts is often foreign. The server already accepts them
  // (core_contract.js identityPatch: /^\+?\d[\d\s-]{6,}$/), so the form was the only thing refusing.
  // ⚠️ This does NOT guess a country. 11–15 digits is already a whole E.164 number (country code +
  //    subscriber); only the + was missing, and adding it changes no digit. What stays unrepaired
  //    is deliberate: a leading 0 is a national trunk prefix (the country is genuinely unknown), and
  //    10 digits or fewer could be a local number from anywhere — those still ask the agent.
  else if (!d.startsWith('+') && /^[1-9][0-9]{10,14}$/.test(d)) d = '+' + d
  if (d.indexOf('+') > 0) return s                    // a + in the middle is a typo, not a format
  return /^\+[0-9]{8,15}$/.test(d) ? d : s
}

export function contactProblems(p) {
  const out = []
  const email = String(p?.email || '').trim()
  const phone = String(p?.phone || '').trim()
  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) out.push('email')
  // Judged on the NORMALISED form, so the rule no longer guesses a country from a length: every
  // accepted number names its own country code, and the only question left is whether the rest is
  // a plausible subscriber number. 8–15 is E.164's own range.
  if (phone && !/^\+[0-9]{8,15}$/.test(normalizePhone(phone))) out.push('phone')

  return out
}
